module.exports = __webpack_public_path__ + "img/bd_logo.c46126c1.png";